
import { Link } from 'react-router-dom';

export default function HealthManagement() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center">
                <div className="w-10 h-10 mr-3 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-lg transform rotate-12 shadow-lg"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-lg"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-600" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </Link>
            </div>
            <nav className="hidden md:flex space-x-8">
              <Link to="/services" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">サービス</Link>
              <Link to="/health-support" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">健康サポート</Link>
              <Link to="/pharmacist-resources" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">薬剤師向け</Link>
              <Link to="/information" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">情報提供</Link>
            </nav>
            <button className="md:hidden p-2">
              <i className="ri-menu-line text-xl"></i>
            </button>
          </div>
        </div>
      </header>

      {/* Article Header */}
      <section className="py-16 bg-gradient-to-br from-green-50 to-blue-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <div className="flex items-center justify-center mb-4">
              <div className="w-12 h-12 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-full flex items-center justify-center mr-4">
                <i className="ri-user-line text-white text-lg"></i>
              </div>
              <div>
                <p className="text-teal-600 font-semibold">ビースト君</p>
                <p className="text-gray-500 text-sm">2025年10月1日</p>
              </div>
            </div>
            <h1 className="text-4xl font-bold text-gray-900 mb-4">薬剤師が教える筋トレと健康管理</h1>
            <p className="text-xl text-gray-600">薬学知識と筋トレ経験を活かした効果的な健康管理方法をお伝えします</p>
          </div>
          <div className="flex justify-center">
            <img 
              src="https://public.readdy.ai/ai/img_res/92db9fbb5b2e7d7c19ec0418805a9013.jpg"
              alt="筋トレと健康管理"
              className="w-full max-w-2xl h-80 object-cover object-top rounded-xl shadow-lg"
            />
          </div>
        </div>
      </section>

      {/* Article Content */}
      <article className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <p className="text-lg text-gray-700 mb-8">
              こんにちは、ビースト君です！今日は薬剤師としての知識と筋トレ経験を組み合わせて、
              効果的な健康管理方法についてお話しします。薬だけでなく、運動や栄養も健康には欠かせません。
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-6">筋トレが健康に与える効果</h2>
            
            <div className="bg-green-50 rounded-xl p-6 mb-8">
              <h3 className="text-xl font-semibold text-green-800 mb-4">筋トレの健康効果</h3>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">代謝向上</h4>
                  <p className="text-gray-600 text-sm">筋肉量増加により基礎代謝が向上し、糖尿病や肥満の予防に効果的</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">骨密度向上</h4>
                  <p className="text-gray-600 text-sm">負荷をかけることで骨密度が向上し、骨粗鬆症の予防につながる</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">心血管機能改善</h4>
                  <p className="text-gray-600 text-sm">血圧や血糖値の改善、心疾患リスクの低下が期待できる</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">メンタルヘルス</h4>
                  <p className="text-gray-600 text-sm">エンドルフィン分泌によりストレス軽減、うつ病予防効果</p>
                </div>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-6">薬剤師が推奨する運動プログラム</h2>
            
            <p className="text-gray-700 mb-6">
              薬剤師として患者さんの健康状態を見てきた経験から、安全で効果的な運動プログラムをご提案します。
              特に慢性疾患をお持ちの方は、医師と相談しながら進めることが大切です。
            </p>

            <div className="bg-blue-50 rounded-xl p-6 mb-8">
              <h3 className="text-xl font-semibold text-blue-800 mb-4">週間運動プログラム例</h3>
              <div className="space-y-4">
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">月・水・金：筋力トレーニング</h4>
                  <ul className="text-gray-600 text-sm space-y-1">
                    <li>• スクワット：3セット × 10-15回</li>
                    <li>• 腕立て伏せ：3セット × 8-12回</li>
                    <li>• プランク：3セット × 30-60秒</li>
                    <li>• ダンベル運動：各部位3セット</li>
                  </ul>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">火・木・土：有酸素運動</h4>
                  <ul className="text-gray-600 text-sm space-y-1">
                    <li>• ウォーキング：30-45分</li>
                    <li>• ジョギング：20-30分</li>
                    <li>• サイクリング：30-45分</li>
                    <li>• 水泳：20-30分</li>
                  </ul>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">日曜日：アクティブレスト</h4>
                  <ul className="text-gray-600 text-sm space-y-1">
                    <li>• ストレッチ：15-20分</li>
                    <li>• ヨガ：30-45分</li>
                    <li>• 軽い散歩：20-30分</li>
                  </ul>
                </div>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-6">サプリメントの正しい使い方</h2>
            
            <p className="text-gray-700 mb-6">
              筋トレをする方からよく相談されるサプリメントについて、薬剤師の視点から正しい使い方をお伝えします。
              サプリメントは「補助」であり、バランスの良い食事が基本です。
            </p>

            <div className="bg-yellow-50 rounded-xl p-6 mb-8">
              <h3 className="text-xl font-semibold text-yellow-800 mb-4">おすすめサプリメント</h3>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">プロテイン</h4>
                  <p className="text-gray-600 text-sm mb-2">筋肉合成に必要なタンパク質を効率的に摂取</p>
                  <p className="text-xs text-gray-500">摂取量：体重1kgあたり1.2-2.0g/日</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">クレアチン</h4>
                  <p className="text-gray-600 text-sm mb-2">筋力向上と筋肉量増加をサポート</p>
                  <p className="text-xs text-gray-500">摂取量：3-5g/日（継続摂取）</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">ビタミンD</h4>
                  <p className="text-gray-600 text-sm mb-2">骨の健康と筋機能維持に重要</p>
                  <p className="text-xs text-gray-500">摂取量：1000-2000IU/日</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">オメガ3脂肪酸</h4>
                  <p className="text-gray-600 text-sm mb-2">炎症抑制と心血管健康をサポート</p>
                  <p className="text-xs text-gray-500">摂取量：1-3g/日（EPA+DHA）</p>
                </div>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-6">薬との相互作用に注意</h2>
            
            <p className="text-gray-700 mb-6">
              薬剤師として特に注意していただきたいのが、サプリメントと処方薬の相互作用です。
              運動やサプリメントを始める前に、必ず医師や薬剤師に相談してください。
            </p>

            <div className="bg-red-50 rounded-xl p-6 mb-8">
              <h3 className="text-xl font-semibold text-red-800 mb-4">注意が必要な組み合わせ</h3>
              <div className="space-y-4">
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">血圧降下薬 × 激しい運動</h4>
                  <p className="text-gray-600 text-sm">急激な血圧低下のリスクがあるため、運動強度を段階的に上げる</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">糖尿病薬 × 長時間運動</h4>
                  <p className="text-gray-600 text-sm">低血糖のリスクがあるため、血糖値モニタリングが重要</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">抗凝固薬 × プロテイン大量摂取</h4>
                  <p className="text-gray-600 text-sm">ビタミンKを含む製品は薬効に影響する可能性</p>
                </div>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-6">継続のコツ</h2>
            
            <p className="text-gray-700 mb-6">
              薬の服薬と同じように、運動も継続が最も重要です。無理をせず、自分のペースで続けることが成功の秘訣です。
            </p>

            <div className="bg-teal-50 rounded-xl p-6 mb-8">
              <h3 className="text-xl font-semibold text-teal-800 mb-4">継続のための工夫</h3>
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">目標設定</h4>
                  <p className="text-gray-600 text-sm">小さな目標から始めて、達成感を積み重ねる</p>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">記録をつける</h4>
                  <p className="text-gray-600 text-sm">運動日記や体重記録で変化を可視化する</p>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">仲間を作る</h4>
                  <p className="text-gray-600 text-sm">一緒に運動する仲間がいるとモチベーション維持</p>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">楽しむ</h4>
                  <p className="text-gray-600 text-sm">好きな音楽を聞きながら、楽しく運動する</p>
                </div>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-6">まとめ</h2>
            
            <p className="text-gray-700 mb-6">
              健康管理は薬だけでなく、運動、栄養、休息のバランスが大切です。
              薬剤師として、そして筋トレ愛好家として、皆さんの健康づくりをサポートしていきます。
            </p>

            <div className="bg-teal-50 rounded-xl p-6">
              <h3 className="text-xl font-semibold text-teal-800 mb-4">ビースト君からのメッセージ</h3>
              <p className="text-gray-700">
                健康な体は一日にして成らず。薬も運動も、継続することで効果が現れます。
                分からないことがあったら、いつでも薬剤師に相談してください。一緒に健康な体を作っていきましょう！💪
              </p>
            </div>
          </div>
        </div>
      </article>

      {/* Related Articles */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">関連記事</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <Link to="/beast-blog/effective-medication" className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow border border-gray-100 overflow-hidden cursor-pointer">
              <img 
                src="https://readdy.ai/api/search-image?query=Muscular%20anime%20pharmacist%20character%20with%20black%20two-block%20haircut%20explaining%20medicine%20timing%20and%20proper%20medication%20usage%2C%20educational%20illustration%20with%20clock%20and%20medicine%20schedule%2C%20friendly%20cartoon%20style%2C%20professional%20healthcare%20setting&width=400&height=250&seq=beast-medication-timing-related-updated&orientation=landscape"
                alt="薬の効果的な飲み方"
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">薬の効果的な飲み方とタイミング</h3>
                <p className="text-gray-600">薬の効果を最大限に引き出すための正しい服用方法について解説します</p>
              </div>
            </Link>
            <Link to="/beast-blog/otc-selection" className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow border border-gray-100 overflow-hidden cursor-pointer">
              <img 
                src="https://readdy.ai/api/search-image?query=Muscular%20anime%20pharmacist%20character%20with%20black%20two-block%20haircut%20in%20pharmacy%20setting%20explaining%20OTC%20medicines%2C%20cartoon%20illustration%20with%20medicine%20shelves%20and%20friendly%20consultation%20scene&width=400&height=250&seq=beast-otc-selection-related-updated&orientation=landscape"
                alt="OTC医薬品"
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">市販薬選びで失敗しないコツ</h3>
                <p className="text-gray-600">薬局でよく聞かれる市販薬の選び方について解説します</p>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center mb-4">
                <div className="w-8 h-8 mr-2 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg transform rotate-12"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-300 to-emerald-300 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-sm"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-400" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </div>
              <p className="text-gray-400">
                患者さんと薬剤師をつなぐ総合医療情報プラットフォーム
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">患者さん向け</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/health-support" className="hover:text-white cursor-pointer">健康サポート</Link></li>
                <li><Link to="/self-care" className="hover:text-white cursor-pointer">セルフケア</Link></li>
                <li><Link to="/otc" className="hover:text-white cursor-pointer">OTC医薬品</Link></li>
                <li><Link to="/kampo" className="hover:text-white cursor-pointer">漢方相談</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">薬剤師向け</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/pharmacist-resources" className="hover:text-white cursor-pointer">専門リソース</Link></li>
                <li><Link to="/sterile-preparation" className="hover:text-white cursor-pointer">無菌調剤</Link></li>
                <li><Link to="/home-care" className="hover:text-white cursor-pointer">在宅医療</Link></li>
                <li><Link to="/dx" className="hover:text-white cursor-pointer">薬局DX</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">情報・リンク</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/information" className="hover:text-white cursor-pointer">公的機関リンク</Link></li>
                <li><Link to="/guidelines" className="hover:text-white cursor-pointer">疾患ガイドライン</Link></li>
                <li><Link to="/career" className="hover:text-white cursor-pointer">転職情報</Link></li>
                <li><Link to="/entertainment" className="hover:text-white cursor-pointer">エンタメ</Link></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 みんなの薬局～Pharmacare～. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white cursor-pointer">Website Builder</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
